import Button from '../../../../UI/Button/Button';
import Translation from '../../../lang/Translation';
import useStyles from './CurrentLocation.styles';
import LocationIcon from '../../ui/svg/Components/LocationIcon';

export function CurrentLocation() {
  const classes = useStyles();
  
  return (
    <div className={classes.currentLocation}>
      <Button
        textOnly
        leftAlign
        noStyle
        id="currentLocation"
        icon={<LocationIcon />}
      >
        <Translation>collection.search.autocomplete</Translation>
      </Button>
    </div>
  );
}

export default CurrentLocation;
